module.exports = __webpack_public_path__ + "static/media/IMG_1465.f4309c71.jpg";